import React, { Component } from 'react';
import { Grid, Form, Input, Button } from 'semantic-ui-react';
import Slider from 'rc-slider';
import * as classnames from 'classnames';
import 'rc-slider/assets/index.css';
import { findIndex } from 'lodash';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import { required, number, greaterThan0 } from '../../../../../lib/FormValidators';
import { Tech3Input, Tech3Select } from '../../../../../components/FormElements';
import PhotoBoothModal from '../../../../../containers/PhotoBoothModal';
import { createAnnotation, patchAnnotation } from '../../../data/analysis/annotationsActions';

export const SIGNAL_COLORS = [
  [
    '#ffffff',
    '#ffcccc',
    '#ffcc99',
    '#ffff99',
    '#ffffcc',
    '#99ff99',
    '#99ffff',
    '#ccffff',
    '#ccccff',
    '#ffccff'
  ],
  [
    '#cccccc',
    '#ff6666',
    '#ff9966',
    '#ffff66',
    '#ffff33',
    '#66ff99',
    '#33ffff',
    '#66ffff',
    '#9999ff',
    '#ff99ff'
  ],
  [
    '#c0c0c0',
    '#ff0000',
    '#ff9900',
    '#ffcc66',
    '#ffff00',
    '#33ff33',
    '#66cccc',
    '#33ccff',
    '#6666cc',
    '#cc66cc'
  ],
  [
    '#999999',
    '#cc0000',
    '#ff6600',
    '#ffcc33',
    '#ffcc00',
    '#33cc00',
    '#00cccc',
    '#3366ff',
    '#6633ff',
    '#cc33cc'
  ],
  [
    '#666666',
    '#990000',
    '#cc6600',
    '#cc9933',
    '#999900',
    '#009900',
    '#339999',
    '#3333ff',
    '#6600cc',
    '#993399'
  ],
  [
    '#333333',
    '#660000',
    '#993300',
    '#996633',
    '#666600',
    '#006600',
    '#336666',
    '#000099',
    '#333399',
    '#663366'
  ],
  [
    '#000000',
    '#330000',
    '#663300',
    '#663333',
    '#333300',
    '#003300',
    '#003333',
    '#000066',
    '#330099',
    '#330033'
  ]
];

const MODAL_NAME = "painPointModal";

const customStyle = {
  width: '25rem'
};

const colorToHex = color => {
  let hex = Number(color).toString(16);
  if (hex.length < 2) {
    hex = `0${hex}`;
  }
  return hex;
};

const fullColorHex = (r, g, b) => {
  return colorToHex(r) + colorToHex(g) + colorToHex(b);
};

class PainPointModal extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(values) {
    if (this.props.activePainpoint) {
      this.props.dispatch(patchAnnotation(this.props.activePainpoint.id, {
        duration: values.duration,
        name: values.name,
        severity: values.severity,
        annotation_type_id: values.category
      }))
    }
    else {
      this.props.dispatch(createAnnotation(this.props.activeLayerId, 205, {
        color_r: Math.floor(Math.random() * 256),
        color_g: Math.floor(Math.random() * 256),
        color_b: Math.floor(Math.random() * 256),
        timestamp: this.props.timestamp,
        duration: values.duration,
        name: values.name,
        severity: values.severity,
        annotation_type_id: values.category
      }));
    }
    this.props.onRequestClose();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen && this.props.activePainpoint) {
      this.props.change("name", this.props.activePainpoint.name);
      this.props.change("category", this.props.activePainpoint.annotation_type_id);
      this.props.change("severity", this.props.activePainpoint.severity.toString());
      this.props.change("duration", this.props.activePainpoint.duration);
    }
    if (prevProps.isOpen && !this.props.isOpen) {
      this.props.dispatch(reset(MODAL_NAME));
    }
  }

  render() {
    return (
      <PhotoBoothModal
        {...this.props}
        title={this.props.constructName}
        className="painPointModal"
      >
        <Form onSubmit={this.props.handleSubmit(this.submitForm)}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={6}>
                <Field
                  label="Name"
                  name="name"
                  type="text"
                  component={Tech3Input}
                  validate={[required]}
                />
              </Grid.Column>
              <Grid.Column width={6} className='leftElement'>
              <Field
                  label="Category"
                  name="category"
                  options={[{key: "option_1", text: "option 1", value: 1}, {key: "option_2", text: "option 2", value: 2}]}
                  type="text"
                  component={Tech3Select}
                  validate={[required]}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={6}>
              <Field
                  label="Severity"
                  name="severity"
                  type="text"
                  options={['0', '1', '2', '3', '4', '5'].map(n => {return {key: `option_${n}`, text: n, value: n}})}
                  component={Tech3Select}
                  validate={[required]}
                />
              </Grid.Column>
              <Grid.Column width={6}>
              <Field
                  label="Duration"
                  name="duration"
                  type="text"
                  component={Tech3Input}
                  validate={[required, number, greaterThan0]}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Button type='submit' className='submit-button' disabled={!this.props.valid}>OK</Button>
        </Form>
      </PhotoBoothModal>
    );
  }
}

const painPointModal = reduxForm({
  form: MODAL_NAME,
  enableReinitialize: true
})(PainPointModal);

export default connect(state => ({
  activeLayerId: state.analysis.single.activeLayerId
}))(painPointModal);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/visualisations/PainPointModal.js